export function rateFor(base, quote) {
  if (!base || !quote || !Number(base.usd) || !Number(quote.usd)) return 0;
  if (base.slug === 'ir-toman') return 1 / Number(quote.toman);
  if (quote.slug === 'ir-toman') return Number(base.toman);
  return Number(base.usd) / Number(quote.usd);
}

export function calculate(state, editedSide = state.lastEdited) {
  const rate = rateFor(state.base, state.quote);
  if (!rate) return state;

  if (editedSide === 'quote') state.baseAmount = state.quoteAmount / rate;
  else state.quoteAmount = state.baseAmount * rate;
  state.rate = rate;
  state.lastEdited = editedSide;
  return state;
}
